import { PieChart, Pie, Cell } from "recharts";
import { motion } from "framer-motion";
import { WhatDoesThisMean } from "../shared/WhatDoesThisMean";

export function ROIGauge({ roiPct, initialInvestment, revenueEarned, amountRemaining, monthsCurrent, monthsRamp, fullyRecovered }) {
  const data = [{ value: roiPct }, { value: 100 - roiPct }];
  const colors = ["#c9a535", "#e6ddc8"];

  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.15 }} className="bg-igc-surface border border-igc-gold/15 p-6 h-full flex flex-col" data-testid="roi-recovery-tracker">
      <p className="text-igc-muted text-xs uppercase tracking-widest mb-2">
        ROI Recovery Tracker
        <WhatDoesThisMean
          testId="roi-explainer"
          text="This shows how much of your initial investment you've earned back in revenue. Once you hit 100%, every dollar after that is pure profit for you."
        />
      </p>
      <div className="relative flex justify-center items-center my-2" style={{ height: 160 }}>
        <PieChart width={160} height={160}>
          <Pie data={data} dataKey="value" innerRadius={58} outerRadius={76} startAngle={90} endAngle={-270} stroke="none">
            {data.map((entry, i) => <Cell key={i} fill={colors[i]} />)}
          </Pie>
        </PieChart>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <p className="font-serif text-3xl text-igc-goldText" data-testid="roi-percentage-value" title="What percent of your initial investment you've earned back so far.">{roiPct}%</p>
          <p className="text-igc-muted text-[10px] uppercase tracking-widest">Recovered</p>
        </div>
      </div>

      {fullyRecovered ? (
        <p className="text-igc-success text-sm text-center font-medium mt-2" data-testid="roi-fully-recovered-message">
          Investment Fully Recovered — Pure Profit Phase Begins
        </p>
      ) : (
        <div className="space-y-1.5 mt-2 text-xs">
          <div className="flex justify-between text-igc-muted"><span>Initial Investment</span><span className="text-igc-cream" data-testid="roi-initial-investment">${initialInvestment.toLocaleString()}</span></div>
          <div className="flex justify-between text-igc-muted"><span>Revenue Earned</span><span className="text-igc-cream" data-testid="roi-revenue-earned">${revenueEarned.toLocaleString()}</span></div>
          <div className="flex justify-between text-igc-muted"><span>Remaining</span><span className="text-igc-cream" data-testid="roi-amount-remaining">${amountRemaining.toLocaleString()}</span></div>
          <div className="flex justify-between text-igc-muted"><span>Est. Recovery (current rate)</span><span className="text-igc-cream" data-testid="roi-months-current">{monthsCurrent ?? "—"} mo</span></div>
          <div className="flex justify-between text-igc-muted"><span>Est. Recovery (full ramp)</span><span className="text-igc-cream" data-testid="roi-months-ramp">{monthsRamp ?? "—"} mo</span></div>
        </div>
      )}
    </motion.div>
  );
}
